import { jwtDecode } from "jwt-decode";

const PASSWORD_EXPIRY_MS = 90 * 24 * 60 * 60 * 1000;
const WARNING_MS = 7 * 24 * 60 * 60 * 1000;

export const buildUserState = (token) => {
    if (!token) {
        return { token: undefined, passwordExpired: false, passwordExpiringSoon: false };
    }

    try {
        const decoded = jwtDecode(token);
        let passwordExpired = false;
        let passwordExpiringSoon = false;

        if (decoded.passwordChangedAt) {
            const elapsed = Date.now() - decoded.passwordChangedAt;
            if (elapsed > PASSWORD_EXPIRY_MS) {
                passwordExpired = true;
            } else if (elapsed > PASSWORD_EXPIRY_MS - WARNING_MS) {
                passwordExpiringSoon = true;
            }
        }

        return { token, passwordExpired, passwordExpiringSoon };
    } catch (_) {
        // Si el decode falla (token malformado), devolver shape seguro sin bloquear
        return { token, passwordExpired: false, passwordExpiringSoon: false };
    }
};

/**
 * Decodifica un JWT de forma segura sin lanzar excepciones.
 * Devuelve {} si el token es null, undefined o está malformado.
 * @param {string|undefined} token
 * @returns {object}
 */
export const safeJwtDecode = (token) => {
    if (!token) return {};
    try {
        return jwtDecode(token);
    } catch (_) {
        return {};
    }
};
